import { Omit } from '@stripe/stripe-js'
import { SidebarGroupsItemProps, SidebarGroupsItem } from 'components/features/pfm/SidebarGroups/SidebarGroupsItem'
import { WithMobileProps } from 'hocs/withMobile/withMobile'
import { RelationId } from 'interfaces/peergroups'
import { FC, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { useShouldBlockRelation } from 'hooks/subscriptionHooks'
import { openSubscriptionPageActionCreator } from 'actions/floatingPanesActions'
import { PremiumOnly } from 'components/features/pfm/PremiumOnly/PremiumOnly'

type SidebarGroupsItemPremiumWrapperProps =
  & Omit<SidebarGroupsItemProps, keyof WithMobileProps>
  & {
    relationId: RelationId | 'member'
  }
export const SidebarGroupsItemPremiumWrapper: FC<SidebarGroupsItemPremiumWrapperProps> = (props) => {
  const { children, onShowPopup, onHidePopup, onSelect, icon, relationId, ...restProps } = props

  const dispatch = useStoreDispatch()

  const shouldBlockRelation = useShouldBlockRelation(relationId)
  const handleSelect = useCallback(() => {
    if (shouldBlockRelation) {
      dispatch(openSubscriptionPageActionCreator())
      return
    }

    onSelect && onSelect()
  }, [dispatch, shouldBlockRelation, onSelect])
  return (
    <SidebarGroupsItem
      { ...restProps }
      onShowPopup={ !shouldBlockRelation && onShowPopup || onHidePopup }
      onHidePopup={ onHidePopup }
      onSelect={ handleSelect }
      blockPopup={ shouldBlockRelation }
      icon={ !shouldBlockRelation && icon }
    >
      <PremiumOnly isBlocked={ !!shouldBlockRelation }>
        { children }
      </PremiumOnly>
    </SidebarGroupsItem>
  )
}
